import { Address, Asset, addressEqual } from 'nftx.js';
import Collection from './Collection';
import useVaults from '@/application/read/vaults/useVaults';
import { useMemo } from 'react';
import CollectionVault from '../CollectionVault';
import useCollection from '@/application/read/collections/useCollection';
import {
  getBestBuyPrice,
  getBestSellPrice,
} from '@/application/read/vaults/utils';

const CollectionContainer = ({
  id,
  token,
  name,
  totalHoldings,
  collectionAssets,
  onClick,
  vaultIds,
  type,
}: {
  id: Address;
  token: Address | '';
  name: string;
  collectionAssets: Asset[];
  totalHoldings: number;
  onClick: (vaultId: string) => void;
  vaultIds: string[];
  type: 'buy' | 'sell';
}) => {
  const { data } = useCollection(id);
  const { data: allVaults } = useVaults();
  const vaults = useMemo(() => {
    return allVaults?.filter((v) => addressEqual(v.asset.id, id));
  }, [allVaults, id]);

  const bestPrice = useMemo(() => {
    if (type === 'buy') {
      return getBestBuyPrice(vaults);
    }
    return getBestSellPrice(vaults);
  }, [vaults, type]);

  return (
    <Collection
      type={type}
      totalHoldings={totalHoldings}
      vaultIds={vaultIds}
      id={id}
      token={token}
      name={data?.name || name}
      imageUrl={data?.image}
      onClick={onClick}
      bestPrice={bestPrice}
      collectionVaults={vaultIds.map((vaultId) => (
        <li key={vaultId}>
          <CollectionVault
            type={type}
            vaultId={vaultId}
            collectionAssets={collectionAssets}
            onClick={() => onClick(vaultId)}
          />
        </li>
      ))}
    />
  );
};

export default CollectionContainer;
